export const RAIL_TEAM_PATH = "/settings/team";
export const RAIL_TEMPLATES_PATH = "/channels/whatsapp?tab=templates";

function isWithin(pathname: string, base: string): boolean {
  return pathname === base || pathname.startsWith(`${base}/`);
}

function isTemplatesWorkspace(pathname: string, search: string): boolean {
  if (pathname !== "/channels/whatsapp") return false;
  return new URLSearchParams(search).get("tab") === "templates";
}

/** Rail highlight. Settings yields to Team on `/settings/team`. Channels yields to Templates on the templates tab. */
export function isRailItemActive(pathname: string, to: string, search = ""): boolean {
  if (to === RAIL_TEMPLATES_PATH) return isTemplatesWorkspace(pathname, search);
  if (to === "/channels") return isWithin(pathname, to) && !isTemplatesWorkspace(pathname, search);
  if (to === "/settings") return isWithin(pathname, to) && !isWithin(pathname, RAIL_TEAM_PATH);
  return isWithin(pathname, to);
}
